import { render, staticRenderFns } from "./bookNow.vue?vue&type=template&id=22169065&scoped=true"
import script from "./bookNow.vue?vue&type=script&lang=js"
export * from "./bookNow.vue?vue&type=script&lang=js"
import style0 from "./bookNow.vue?vue&type=style&index=0&id=22169065&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22169065",
  null
  
)

export default component.exports